import { Card, Grid, IconButton, Link } from "@mui/material";
import { motion } from "framer-motion";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import { baseurl } from "../config";
import { useNavigate } from "react-router-dom";
export type homePageCardType = {
  image: string;
  heading: string;
  content: string;
  path: string;
};
const HomePageCard = ({ content, heading, image, path }: homePageCardType) => {
  const navigate = useNavigate();
  return (
    <Link href={`${path}`} underline="none">
      <Card
        sx={{ maxWidth: 300, minHeight: 390, bgcolor: "#37211D" }}
        component={motion.div}
        whileHover={{
          scale: 1.05,
          transition: { duration: 0.5 },
        }}
        whileTap={{ scale: 0.9 }}
        initial={{ scale: 0 }}
        whileInView={{ scale: 1, transition: { duration: 0.5 } }}
      >
        <img
          src={`${baseurl}${image}`}
          alt={`${image}`}
          style={{ height: "200px" }}
        />
        <Grid container p={2}>
          <Grid
            container
            flexDirection={"row"}
            alignItems="center"
            justifyContent={"space-between"}
            item
            xs={12}
            spacing={2}
          >
            <Grid item sx={{ color: "white", fontSize: "1.7rem" }}>
              {heading}
            </Grid>
            <Grid
              item
              container
              justifyContent={"center"}
              alignItems={"center"}
              xs={2}
            >
              <Grid item>
                <IconButton sx={{ color: "text.secondary" }}>
                  <ArrowCircleRightOutlinedIcon fontSize="large" />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ color: "#F4AE4A" }}>
            {content}
          </Grid>
        </Grid>
      </Card>
    </Link>
  );
};

export default HomePageCard;
